import { BaseService, UI_VARIANT } from '@usercentrics/cmp-browser-sdk';
import {
  Container,
  ServiceInfo,
  ServiceLabelButton,
  ServiceLabelButtonWrapper,
  ServiceName,
} from './CategoryCardContent.styles';
import { FunctionalComponent, h } from 'preact';
import { InfoIcon } from '../../assets';
import SubServicesInfo from '../SubServices/SubServicesInfo';
import Toggle from '../Toggles/Toggle/Toggle';
import { UC_UI_GLOBAL_NAMESPACE } from '../../constants';
import { UICategory } from '../../contexts/CategoryContext';
import { memo } from 'preact/compat';
import { useUiContext } from '../../contexts/UiContext';

type Props = {
  category: UICategory;
  detailedCategoryToggleAriaLabel: string;
  onToggle: (service: BaseService) => void;
  service: BaseService;
  showServicesToggles: boolean;
};

const CategoryCardContent: FunctionalComponent<Props> = ({
  category,
  detailedCategoryToggleAriaLabel,
  onToggle,
  showServicesToggles,
  service,
}) => {
  const { uiVariant, isAmpEnabled, setScrollToIdTabViewCategoryPurpose, setScrollToSubServices } = useUiContext();
  const isCcpa = uiVariant === UI_VARIANT.CCPA;
  const isTcf = uiVariant === UI_VARIANT.TCF;

  const onToggleHandler = (): void => {
    if (!service.isEssential) {
      onToggle(service);
    }
  };

  const onClickToServiceDetails = async (): Promise<void> => {
    const ucUi = window[UC_UI_GLOBAL_NAMESPACE];

    if (ucUi) {
      await ucUi.showSecondLayer(service.id);
    }
    setScrollToIdTabViewCategoryPurpose(category.slug);
  };

  const onClickToSubServices = async (): Promise<void> => {
    await onClickToServiceDetails();
    // SetTimeout is necessary because we need to first open the service
    // before scrolling to the sub service
    setTimeout(() => {
      setScrollToSubServices(true);
    });
  };

  const getServiceLabel = () => <ServiceName>{service.name}</ServiceName>;

  const getServiceActionComponent = () => (
    <ServiceInfo onClick={onClickToServiceDetails} aria-label={detailedCategoryToggleAriaLabel}>
      <InfoIcon />
    </ServiceInfo>
  );

  const getLabelExtraInfo = () => {
    const { subServicesLength } = service;

    return subServicesLength > 0 ? (
      <ServiceLabelButtonWrapper>
        <ServiceLabelButton
          onClick={(e) => {
            e.stopPropagation();
            onClickToSubServices();
          }}
        >
          <SubServicesInfo size={service.subServicesLength} />
        </ServiceLabelButton>
      </ServiceLabelButtonWrapper>
    ) : null;
  };

  return (
    <Container>
      <Toggle
        checked={service.consent.status}
        id={`${service.id}`}
        isDisabled={service.isEssential}
        hideToggle={!showServicesToggles || isCcpa || (isAmpEnabled && !isTcf)}
        label={getServiceLabel()}
        labelExtraInfo={getLabelExtraInfo()}
        labelActionComponent={getServiceActionComponent()}
        onToggle={onToggleHandler}
        size="small"
      />
    </Container>
  );
};

export default memo(CategoryCardContent);
